import React,{ Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { guardaDireccion } from '../actions'
import Menu from '../components/user_menu'
class Direccion extends Component{
  
  constructor(props) {
    super(props);
    this.state = {
      nombre:"",
      calle:"",
      altura:"",
      piso:"",
      tipo:"",
      pais:"1",
      provincia:"1",
      ciudad:"1",
      codpost:"",
      cont_apellido:"",
      cont_nombre:"",
      cont_empresa:"",
      cont_telefono:"",
      cont_correo:""
    }
    this.guardaDireccion = this.guardaDireccion.bind(this)
    this.cambia = this.cambia.bind(this)
  }

  componentDidMount(){
    if(!this.props.usuario.user){
      this.props.history.push("/login")
    }
  }

  componentDidUpdate(prevProps, prevState){

  }


  guardaDireccion = (e) => {
    e.preventDefault()
    var data ={
      nombre:this.state.nombre,
      calle:this.state.calle,
      altura:this.state.altura,
      piso:this.state.piso,
      tipo:this.state.tipo,
      pais:this.state.pais,
      provincia:this.state.provincia,
      ciudad:this.state.ciudad,
      codpost:this.state.codpost,
      cont_apellido:this.state.cont_apellido,
      cont_nombre:this.state.cont_nombre,
      cont_empresa:this.state.cont_empresa,
      cont_telefono:this.state.cont_telefono,
      cont_correo:this.state.cont_correo
    }
    this.props.guardaDireccion(this.props.usuario.user.uid,data)
  }

    cambia = (key,value)=>{
    this.setState({[key]:value})
  }



	render(){
		return (
			 <section className="container row mb-5 sombraHead mt-3 clearfix" >
          <div className="col-md-4 mb-3">
            <Menu />
          </div>
          <div className="col-md-6 mb-3">


			 	<h1 className="display-4">Direccion</h1>
        <form>

          <div className="form-group">
            <label>Nombre</label>
            <input type="text" className="form-control" id="nombre" aria-describedby="emailHelp" placeholder="Nombre descriptivo de la direccion" onChange={evt => this.cambia('nombre',evt.target.value)}/>
          </div>

          <div className="form-row">
            <div className="col-md-6 mb-3">
              <label>Calle</label>
              <input type="text" className="form-control" id="calle" aria-describedby="emailHelp" placeholder="Ingrese el nombre de la calle" onChange={evt => this.cambia('calle',evt.target.value)}/>
              <small id="emailHelp" className="form-text text-muted">xxx</small>
            </div>
            <div className="col-md-2 mb-3">
              <label>Altura</label>
              <input type="text" className="form-control" id="Altura" placeholder="Altura" onChange={evt => this.cambia('altura',evt.target.value)}/>
            </div>
            <div className="col-md-2 mb-3">
              <label>Piso</label>
              <input type="text" className="form-control" id="Piso" placeholder="Piso" onChange={evt => this.cambia('piso',evt.target.value)} />
            </div>
            <div className="col-md-2 mb-3">
              <label>Tipo</label>
              <input type="text" className="form-control" id="Tipo" placeholder="Tipo" onChange={evt => this.cambia('tipo',evt.target.value)}/>
            </div>
          </div>

          <div className="form-row">
            <div className="col-md-3 mb-3">
              <label>Pais</label>
              <select className="form-control form-control-sm" id="Pais" onChange={evt => this.cambia('pais',evt.target.value)}>
                <option value="1">Argentina</option>
              </select>
            </div>

            <div className="col-md-3 mb-3">
              <label>Provincia</label>
              <select className="form-control form-control-sm" id="Provincia" onChange={evt => this.cambia('provincia',evt.target.value)}>
                    <option value="Buenos Aires">Buenos Aires</option>
                    <option value="Catamarca">Catamarca</option>
                    <option value="Chaco">Chaco</option>
                    <option value="Chubut">Chubut</option>
                    <option value="Ciudad Autónoma de">Ciudad Autónoma de</option>
                    <option value="Buenos Aires">Buenos Aires</option>
                    <option value="Córdoba">Córdoba</option>
                    <option value="Corrientes">Corrientes</option>
                    <option value="Entre Ríos">Entre Ríos</option>
                    <option value="Formosa">Formosa</option>
                    <option value="Jujuy">Jujuy</option>
                    <option value="La Pampa">La Pampa</option>
                    <option value="La Rioja">La Rioja</option>
                    <option value="Mendoza">Mendoza</option>
                    <option value="Misiones">Misiones</option>
                    <option value="Neuquén">Neuquén</option>
                    <option value="Río Negro">Río Negro</option>
                    <option value="Salta">Salta</option>
                    <option value="San Juan">San Juan</option>
                    <option value="San Luis">San Luis</option>
                    <option value="Santa Cruz">Santa Cruz</option>
                    <option value="Santa Fe">Santa Fe</option>
                    <option value="Santiago del Estero">Santiago del Estero</option>
                    <option value="Tierra del Fuego">Tierra del Fuego</option>
                    <option value="Tucumán">Tucumán</option>
              </select>
            </div>

            <div className="col-md-3 mb-3">
              <label>Ciudad</label>
              <select className="form-control form-control-sm" id="Ciudad" onChange={evt => this.cambia('ciudad',evt.target.value)}>
                <option value="1">Ciudad Autónoma de Buenos Aires</option>
              </select>
            </div>

            <div className="col-md-3 mb-3">
              <label>Cod.Post</label>
              <input type="text" className="form-control" id="codpost" placeholder="Codigo Postal" onChange={evt => this.cambia('codpost',evt.target.value)}/>
            </div>
          </div>

          <p className="h5">Datos contacto</p>

          <div className="form-row">
            <div className="col-md-6 mb-3">
              <label>Nombre</label>
              <input type="text" className="form-control" id="cont_nombre"  placeholder="Ingrese el nombre del contacto" onChange={evt => this.cambia('cont_nombre',evt.target.value)}/>
            </div>
            <div className="col-md-6 mb-3">
              <label>Apellido</label>
              <input type="text" className="form-control" id="cont_apellido" placeholder="Ingrese el apellido del contacto" onChange={evt => this.cambia('cont_apellido',evt.target.value)}/>
            </div>
          </div>

          <div className="form-row">
            <div className="col-md-4 mb-3">
              <label>Empresa</label>
              <input type="text" className="form-control" id="empresa"  placeholder="Ingrese el nombre de la empresa" onChange={evt => this.cambia('cont_empresa',evt.target.value)}/>
            </div>
            <div className="col-md-4 mb-3">
              <label>Telefono</label>
              <input type="text" className="form-control" id="cont_telefono" placeholder="Ingrese el telefono del contacto" onChange={evt => this.cambia('cont_telefono',evt.target.value)}/>
            </div>
            <div className="col-md-4 mb-3">
              <label>Correo</label>
              <input type="email" className="form-control" id="cont_correo" aria-describedby="emailHelp" placeholder="Enter email" onChange={evt => this.cambia('cont_correo',evt.target.value)}/>
            </div>
          </div>

          <button type="submit" className="btn btn-primary" onClick={this.guardaDireccion}>Envia</button>
        </form>
			</div>
      </section>
		)
	}

};

const mapStateToProps = (state, ownProps) => {
  return {
      usuario: state.usuario
    }
}

const mapDispatchToProps = dispatch => {
  return {
    guardaDireccion: (uid,dato) => {
      dispatch(guardaDireccion(uid,dato))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Direccion)



// WEBPACK FOOTER //
// ./src/containers/direccion.js